import React, { useState } from "react";
import { useLang } from "../context/LanguageContext";
import useReveal from "../hooks/useReveal";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const { t } = useLang();
  const f = t.faq;
  const ref = useReveal();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="section-line" />
            <span className="text-xs font-700 uppercase tracking-[0.25em] font-display text-[#f5871f]">
              {f.eyebrow}
            </span>
            <span className="section-line" />
          </div>
          <h2 className="font-display font-700 text-3xl md:text-4xl uppercase text-[#0d2140]">{f.title}</h2>
        </div>

        <div ref={ref} className="reveal mt-12 space-y-4">
          {f.items.map((item, i) => {
            const isOpen = openIdx === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border transition-colors ${
                  isOpen ? "border-[#f5871f]/50 bg-[#f4f6f9]" : "border-[#0d2140]/10 bg-white"
                }`}
              >
                <button
                  onClick={() => setOpenIdx(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-display font-600 text-[#0d2140] text-lg uppercase">{item.q}</span>
                  <span className="shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-[#f5871f] text-white">
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-60" : "max-h-0"
                  }`}
                >
                  <p className="px-6 pb-5 text-[#0d2140]/65 text-sm leading-relaxed">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
